"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Public Load Boards
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsApi = exports.SettingsApiFactory = exports.SettingsApiFp = exports.SettingsApiAxiosParamCreator = exports.LoadPostApi = exports.LoadPostApiFactory = exports.LoadPostApiFp = exports.LoadPostApiAxiosParamCreator = exports.CapacitySearchApi = exports.CapacitySearchApiFactory = exports.CapacitySearchApiFp = exports.CapacitySearchApiAxiosParamCreator = exports.BootItNowApi = exports.BootItNowApiFactory = exports.BootItNowApiFp = exports.BootItNowApiAxiosParamCreator = exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = exports.WeightUnit = exports.TransactionTypeForNonBookableOffer = exports.TransactionTypeForBookableWithWebhooks = exports.TransactionTypeForBookableWithDATPortal = exports.TemperatureUnit = exports.StopType = exports.StatusEnum = exports.StateProvinceEnum = exports.PreferredContactMethodEnum = exports.Permissions = exports.ModeEnum = exports.MarketAreaEnum = exports.LocationType = exports.LoadboardType = exports.FullPartialEnum = exports.EquipmentTypeEnum = exports.EquipmentType = exports.EnableBookNowStatus = exports.DistanceUnitsEnum = exports.DimensionUnit = exports.ContactType = exports.AppointmentType = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AppointmentType = {
    Fcfs: 'FCFS',
    Invalid: 'INVALID',
    Fixed: 'FIXED',
    NoticeCall: 'NOTICE_CALL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ContactType = {
    AccountRep: 'ACCOUNT_REP',
    Administrator: 'ADMINISTRATOR',
    AfterHoursContact: 'AFTER_HOURS_CONTACT',
    AppointmentScheduler: 'APPOINTMENT_SCHEDULER',
    Agent: 'AGENT',
    Broker: 'BROKER',
    CarrierRep: 'CARRIER_REP',
    ForwarderContact: 'FORWARDER_CONTACT',
    Other: 'OTHER',
    ReceivingContact: 'RECEIVING_CONTACT',
    SalesRep: 'SALES_REP',
    ShipperContact: 'SHIPPER_CONTACT',
    UltimateReceiver: 'ULTIMATE_RECEIVER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DimensionUnit = {
    Cm: 'CM',
    Ft: 'FT',
    Ft3: 'FT3',
    In: 'IN',
    M: 'M'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DistanceUnitsEnum = {
    Mile: 'MILE',
    Km: 'KM'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.EnableBookNowStatus = {
    Disabled: 'disabled',
    Accepted: 'accepted',
    Initiated: 'initiated',
    PartialFailed: 'partial_failed',
    Failed: 'failed',
    Enabled: 'enabled'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.EquipmentType = {
    DryVan: 'DRY_VAN',
    Reefer: 'REEFER',
    Flatbed: 'FLATBED',
    Container: 'CONTAINER',
    Autohauler: 'AUTOHAULER',
    Bulk: 'BULK',
    Tanker: 'TANKER',
    CurtainSide: 'CURTAIN_SIDE',
    Hopper: 'HOPPER',
    DropDeck: 'DROP_DECK',
    Tilt: 'TILT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    Conestoga: 'CONESTOGA',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    BTrain: 'B_TRAIN',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DumpTrailer: 'DUMP_TRAILER',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StretchTrailer: 'STRETCH_TRAILER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    StepDeck: 'STEP_DECK',
    HopperBottom: 'HOPPER_BOTTOM',
    Pneumatic: 'PNEUMATIC',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    AutoCarrier: 'AUTO_CARRIER',
    Conveyor: 'CONVEYOR',
    PowerOnly: 'POWER_ONLY',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    InsulatedVan: 'INSULATED_VAN',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    MovingVan: 'MOVING_VAN',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    VanAirRide: 'VAN_AIR_RIDE',
    VanSprinter: 'VAN_SPRINTER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    Container53Foot: 'CONTAINER_53_FOOT',
    ContainerOversize: 'CONTAINER_OVERSIZE',
    MultiCompartment: 'MULTI_COMPARTMENT',
    ContainerReeferTank20Foot: 'CONTAINER_REEFER_TANK_20_FOOT',
    AutoRackBiLevel: 'AUTO_RACK_BI_LEVEL',
    AutoRackTriLevel: 'AUTO_RACK_TRI_LEVEL',
    AutoMax: 'AUTO_MAX',
    Boxcar: 'BOXCAR',
    BulkheadFlatcar: 'BULKHEAD_FLATCAR',
    CenterbeamFlatcar: 'CENTERBEAM_FLATCAR',
    ChainTieDownFlatcar: 'CHAIN_TIE_DOWN_FLATCAR',
    CoalCar: 'COAL_CAR',
    CoilSteelRailcar: 'COIL_STEEL_RAILCAR',
    CoveredCoilRailcar: 'COVERED_COIL_RAILCAR',
    CoveredHopper: 'COVERED_HOPPER',
    Gondola: 'GONDOLA',
    OpenTopHopper: 'OPEN_TOP_HOPPER',
    PipeFlatcar: 'PIPE_FLATCAR',
    RefrigeratedBoxcar: 'REFRIGERATED_BOXCAR',
    TempControlledTrailer: 'TEMP_CONTROLLED_TRAILER',
    Trailer: 'TRAILER',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.EquipmentTypeEnum = {
    Ac: 'AC',
    C: 'C',
    Ci: 'CI',
    Cr: 'CR',
    Dd: 'DD',
    La: 'LA',
    Dt: 'DT',
    F: 'F',
    Fa: 'FA',
    Bt: 'BT',
    F2: 'F2',
    Fz: 'FZ',
    Fh: 'FH',
    Mx: 'MX',
    Fs: 'FS',
    Ft: 'FT',
    Fm: 'FM',
    Fd: 'FD',
    Fr: 'FR',
    Hb: 'HB',
    Lb: 'LB',
    Mv: 'MV',
    Nu: 'NU',
    Po: 'PO',
    R: 'R',
    Ra: 'RA',
    R2: 'R2',
    Rz: 'RZ',
    Rn: 'RN',
    Rl: 'RL',
    Rm: 'RM',
    Rg: 'RG',
    Sd: 'SD',
    St: 'ST',
    Ta: 'TA',
    Tn: 'TN',
    Ts: 'TS',
    Tt: 'TT',
    V: 'V',
    Va: 'VA',
    Vs: 'VS',
    Vc: 'VC',
    V2: 'V2',
    Vz: 'VZ',
    Vh: 'VH',
    Vi: 'VI',
    Vn: 'VN',
    Vg: 'VG',
    Vl: 'VL',
    Ot: 'OT',
    Vb: 'VB',
    V3: 'V3',
    Vv: 'VV',
    Vm: 'VM',
    Vt: 'VT',
    Vf: 'VF',
    Vr: 'VR',
    Ir: 'IR',
    Rv: 'RV',
    Fc: 'FC',
    Rp: 'RP',
    Vw: 'VW',
    Lr: 'LR',
    Vp: 'VP',
    Sr: 'SR',
    Cv: 'CV',
    Fo: 'FO',
    Lo: 'LO',
    Cn: 'CN',
    Fn: 'FN',
    Sn: 'SN',
    Sb: 'SB'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FullPartialEnum = {
    Full: 'FULL',
    Partial: 'PARTIAL',
    Both: 'BOTH'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LoadboardType = {
    Dat: 'dat',
    Truckstop: 'truckstop',
    InvalidLoadboard: 'invalid_loadboard',
    Internal: 'internal'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LocationType = {
    ContainerYard: 'CONTAINER_YARD',
    Other: 'OTHER',
    BusinessWithDockOrForklift: 'BUSINESS_WITH_DOCK_OR_FORKLIFT',
    BusinessWithoutDockOrForklift: 'BUSINESS_WITHOUT_DOCK_OR_FORKLIFT',
    Residence: 'RESIDENCE',
    CommercialFarm: 'COMMERCIAL_FARM',
    SelfStorage: 'SELF_STORAGE',
    TradeShow: 'TRADE_SHOW',
    ConstructionSite: 'CONSTRUCTION_SITE',
    School: 'SCHOOL',
    GovernmentLocation: 'GOVERNMENT_LOCATION',
    RestaurantHotelGolfCoursePark: 'RESTAURANT_HOTEL_GOLF_COURSE_PARK',
    MilitaryBaseBase: 'MILITARY_BASE_BASE',
    Airport: 'AIRPORT',
    OtherSecuredOrLimitedAccess: 'OTHER_SECURED_OR_LIMITED_ACCESS',
    Terminal: 'TERMINAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.MarketAreaEnum = {
    AbCal: 'AB_CAL',
    AlBir: 'AL_BIR',
    AlDec: 'AL_DEC',
    AlMob: 'AL_MOB',
    AlMon: 'AL_MON',
    ArFay: 'AR_FAY',
    ArLit: 'AR_LIT',
    AzFla: 'AZ_FLA',
    AzPho: 'AZ_PHO',
    AzTuc: 'AZ_TUC',
    BcPri: 'BC_PRI',
    BcVan: 'BC_VAN',
    CaFrs: 'CA_FRS',
    CaLax: 'CA_LAX',
    CaOnt: 'CA_ONT',
    CaSdi: 'CA_SDI',
    CaSfr: 'CA_SFR',
    CaStk: 'CA_STK',
    CoDen: 'CO_DEN',
    CoGra: 'CO_GRA',
    CtHar: 'CT_HAR',
    FlJax: 'FL_JAX',
    FlLak: 'FL_LAK',
    FlMia: 'FL_MIA',
    FlTal: 'FL_TAL',
    GaAtl: 'GA_ATL',
    GaMac: 'GA_MAC',
    GaSav: 'GA_SAV',
    GaTif: 'GA_TIF',
    IaCed: 'IA_CED',
    IaDes: 'IA_DES',
    IaDub: 'IA_DUB',
    IdTwi: 'ID_TWI',
    IlBlo: 'IL_BLO',
    IlChi: 'IL_CHI',
    IlJol: 'IL_JOL',
    IlQui: 'IL_QUI',
    IlRfd: 'IL_RFD',
    IlRoc: 'IL_ROC',
    IlTay: 'IL_TAY',
    InEva: 'IN_EVA',
    InFtw: 'IN_FTW',
    InGry: 'IN_GRY',
    InInd: 'IN_IND',
    InSbd: 'IN_SBD',
    InTer: 'IN_TER',
    KsHut: 'KS_HUT',
    KyBow: 'KY_BOW',
    KyLex: 'KY_LEX',
    KyLou: 'KY_LOU',
    LaNew: 'LA_NEW',
    LaShr: 'LA_SHR',
    MaBos: 'MA_BOS',
    MaSpr: 'MA_SPR',
    MbWin: 'MB_WIN',
    MdBal: 'MD_BAL',
    MeAug: 'ME_AUG',
    MiDet: 'MI_DET',
    MiRap: 'MI_RAP',
    MiSag: 'MI_SAG',
    MnDul: 'MN_DUL',
    MnMin: 'MN_MIN',
    MnStc: 'MN_STC',
    MoGir: 'MO_GIR',
    MoJef: 'MO_JEF',
    MoJop: 'MO_JOP',
    MoKan: 'MO_KAN',
    MoStl: 'MO_STL',
    MsJac: 'MS_JAC',
    MtBil: 'MT_BIL',
    MtMis: 'MT_MIS',
    NbMon: 'NB_MON',
    NcCha: 'NC_CHA',
    NcGre: 'NC_GRE',
    NcRal: 'NC_RAL',
    NcWil: 'NC_WIL',
    NdBis: 'ND_BIS',
    NdFar: 'ND_FAR',
    NeNpl: 'NE_NPL',
    NeOma: 'NE_OMA',
    NfStj: 'NF_STJ',
    NhBri: 'NH_BRI',
    NjEli: 'NJ_ELI',
    NmAlb: 'NM_ALB',
    NsHal: 'NS_HAL',
    NvRen: 'NV_REN',
    NvVeg: 'NV_VEG',
    NyAlb: 'NY_ALB',
    NyBrn: 'NY_BRN',
    NyBuf: 'NY_BUF',
    NyElm: 'NY_ELM',
    NyRoc: 'NY_ROC',
    NySyr: 'NY_SYR',
    OhCin: 'OH_CIN',
    OhCle: 'OH_CLE',
    OhCol: 'OH_COL',
    OhTol: 'OH_TOL',
    OkOkc: 'OK_OKC',
    OkTul: 'OK_TUL',
    OnLon: 'ON_LON',
    OnOtt: 'ON_OTT',
    OnSud: 'ON_SUD',
    OnTor: 'ON_TOR',
    OrMed: 'OR_MED',
    OrPen: 'OR_PEN',
    OrPor: 'OR_POR',
    PaAll: 'PA_ALL',
    PaEri: 'PA_ERI',
    PaHar: 'PA_HAR',
    PaPhi: 'PA_PHI',
    PaPit: 'PA_PIT',
    PqMon: 'PQ_MON',
    PqQue: 'PQ_QUE',
    ScCha: 'SC_CHA',
    ScCol: 'SC_COL',
    ScGre: 'SC_GRE',
    SdRap: 'SD_RAP',
    SdSxf: 'SD_SXF',
    SkReg: 'SK_REG',
    TnCha: 'TN_CHA',
    TnKno: 'TN_KNO',
    TnMem: 'TN_MEM',
    TnNas: 'TN_NAS',
    TxAma: 'TX_AMA',
    TxAnt: 'TX_ANT',
    TxAus: 'TX_AUS',
    TxDal: 'TX_DAL',
    TxElp: 'TX_ELP',
    TxFtw: 'TX_FTW',
    TxHou: 'TX_HOU',
    TxLar: 'TX_LAR',
    TxLub: 'TX_LUB',
    TxMca: 'TX_MCA',
    TxTex: 'TX_TEX',
    UtSlc: 'UT_SLC',
    VaAle: 'VA_ALE',
    VaNor: 'VA_NOR',
    VaRch: 'VA_RCH',
    VaRoa: 'VA_ROA',
    VaWin: 'VA_WIN',
    WaSea: 'WA_SEA',
    WaSpo: 'WA_SPO',
    WiEau: 'WI_EAU',
    WiGre: 'WI_GRE',
    WiMad: 'WI_MAD',
    WiMil: 'WI_MIL',
    WvCha: 'WV_CHA',
    WvHun: 'WV_HUN',
    WyGre: 'WY_GRE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ModeEnum = {
    Ftl: 'FTL',
    Ltl: 'LTL',
    Vltl: 'VLTL',
    Partial: 'PARTIAL',
    Drayage: 'DRAYAGE',
    Intermodal: 'INTERMODAL',
    Invalid: 'INVALID',
    Other: 'OTHER',
    FinalMile: 'FINAL_MILE',
    Parcel: 'PARCEL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Permissions = {
    SearchLoads: 'SEARCH_LOADS',
    SearchCapacity: 'SEARCH_CAPACITY',
    Rating: 'RATING',
    CarrierLookup: 'CARRIER_LOOKUP',
    PostLoad: 'POST_LOAD',
    PostCapacity: 'POST_CAPACITY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PreferredContactMethodEnum = {
    PrimaryPhone: 'PRIMARY_PHONE',
    AlternatePhone: 'ALTERNATE_PHONE',
    Email: 'EMAIL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StateProvinceEnum = {
    Ab: 'AB',
    Ag: 'AG',
    Ak: 'AK',
    Al: 'AL',
    As: 'AS',
    Az: 'AZ',
    Ar: 'AR',
    Bc: 'BC',
    Bj: 'BJ',
    Bs: 'BS',
    Ca: 'CA',
    Ch: 'CH',
    Ci: 'CI',
    Cl: 'CL',
    Co: 'CO',
    Cp: 'CP',
    Ct: 'CT',
    Cu: 'CU',
    Dc: 'DC',
    De: 'DE',
    Df: 'DF',
    Dg: 'DG',
    Em: 'EM',
    Fl: 'FL',
    Ga: 'GA',
    Gj: 'GJ',
    Gr: 'GR',
    Gu: 'GU',
    Hg: 'HG',
    Hi: 'HI',
    Ia: 'IA',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ja: 'JA',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Ma: 'MA',
    Mb: 'MB',
    Md: 'MD',
    Me: 'ME',
    Mh: 'MH',
    Mi: 'MI',
    Mn: 'MN',
    Mo: 'MO',
    Mr: 'MR',
    Ms: 'MS',
    Mt: 'MT',
    Na: 'NA',
    Nb: 'NB',
    Nc: 'NC',
    Nd: 'ND',
    Ne: 'NE',
    Nf: 'NF',
    Nh: 'NH',
    Nj: 'NJ',
    Nl: 'NL',
    Nm: 'NM',
    Ny: 'NY',
    Nt: 'NT',
    Ns: 'NS',
    Nu: 'NU',
    Nv: 'NV',
    Oa: 'OA',
    Oh: 'OH',
    Ok: 'OK',
    On: 'ON',
    Or: 'OR',
    Pa: 'PA',
    Pe: 'PE',
    Pq: 'PQ',
    Pr: 'PR',
    Pu: 'PU',
    Qa: 'QA',
    Qc: 'QC',
    Qr: 'QR',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Si: 'SI',
    Sk: 'SK',
    Sl: 'SL',
    So: 'SO',
    Ta: 'TA',
    Tl: 'TL',
    Tm: 'TM',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Va: 'VA',
    Vi: 'VI',
    Vl: 'VL',
    Vt: 'VT',
    Wa: 'WA',
    Wv: 'WV',
    Wi: 'WI',
    Wy: 'WY',
    Yc: 'YC',
    Yt: 'YT',
    Zj: 'ZJ',
    Zt: 'ZT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StatusEnum = {
    Invalid: 'INVALID',
    Open: 'OPEN',
    Covered: 'COVERED',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    Reserved: 'RESERVED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StopType = {
    PreloadedTrailerPickup: 'PRELOADED_TRAILER_PICKUP',
    Invalid: 'INVALID',
    LiveUnload: 'LIVE_UNLOAD',
    LiveLoad: 'LIVE_LOAD',
    EmptyTrailerPickup: 'EMPTY_TRAILER_PICKUP',
    EmptyTrailerReturn: 'EMPTY_TRAILER_RETURN',
    DropLoadedTrailer: 'DROP_LOADED_TRAILER',
    ChangeDriver: 'CHANGE_DRIVER',
    ChangePowerUnit: 'CHANGE_POWER_UNIT',
    ChangeTrailer: 'CHANGE_TRAILER',
    ChangeMultiple: 'CHANGE_MULTIPLE',
    BorderStop: 'BORDER_STOP'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemperatureUnit = {
    C: 'C',
    F: 'F'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TransactionTypeForBookableWithDATPortal = {
    DatPortal: 'BOOKABLE_DAT_PORTAL',
    NegotiableDatPortal: 'BOOKABLE_NEGOTIABLE_DAT_PORTAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TransactionTypeForBookableWithWebhooks = {
    Webhooks: 'BOOKABLE_WEBHOOKS',
    NegotiableWebhooks: 'BOOKABLE_NEGOTIABLE_WEBHOOKS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TransactionTypeForNonBookableOffer = {
    NonbookableOfferRate: 'NONBOOKABLE_OFFER_RATE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.WeightUnit = {
    Kg: 'KG',
    Lb: 'LB'
};
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
var AuthenticationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Auth
         * @param {LoadboardName} loadboardName
         * @param {CreateAuthRequest} createAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuthLoadboardsAuthLoadboardNamePost: function (loadboardName, createAuthRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('createAuthLoadboardsAuthLoadboardNamePost', 'loadboardName', loadboardName);
                            // verify required parameter 'createAuthRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createAuthLoadboardsAuthLoadboardNamePost', 'createAuthRequest', createAuthRequest);
                            localVarPath = "/loadboards/auth/{loadboard_name}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAuthRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Auth
         * @param {LoadboardName} loadboardName
         * @param {boolean} [isUser]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthLoadboardsAuthLoadboardNameDelete: function (loadboardName, isUser, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAuthLoadboardsAuthLoadboardNameDelete', 'loadboardName', loadboardName);
                            localVarPath = "/loadboards/auth/{loadboard_name}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (isUser !== undefined) {
                                localVarQueryParameter['is_user'] = isUser;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['user_id'] = userId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get External Auth Service
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet: function (loadboardName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet', 'loadboardName', loadboardName);
                            localVarPath = "/loadboards/auth/{loadboard_name}/external"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Token
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenLoadboardsAuthLoadboardNameGet: function (loadboardName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('getTokenLoadboardsAuthLoadboardNameGet', 'loadboardName', loadboardName);
                            localVarPath = "/loadboards/auth/{loadboard_name}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Active Lb
         * @param {LoadboardName} [loadboardName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveLbLoadboardsAuthGet: function (loadboardName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadboards/auth";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (loadboardName !== undefined) {
                                localVarQueryParameter['loadboard_name'] = loadboardName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AuthenticationApiAxiosParamCreator = AuthenticationApiAxiosParamCreator;
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
var AuthenticationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthenticationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Auth
         * @param {LoadboardName} loadboardName
         * @param {CreateAuthRequest} createAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuthLoadboardsAuthLoadboardNamePost: function (loadboardName, createAuthRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAuthLoadboardsAuthLoadboardNamePost(loadboardName, createAuthRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Auth
         * @param {LoadboardName} loadboardName
         * @param {boolean} [isUser]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthLoadboardsAuthLoadboardNameDelete: function (loadboardName, isUser, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAuthLoadboardsAuthLoadboardNameDelete(loadboardName, isUser, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get External Auth Service
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet: function (loadboardName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet(loadboardName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Token
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenLoadboardsAuthLoadboardNameGet: function (loadboardName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTokenLoadboardsAuthLoadboardNameGet(loadboardName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Active Lb
         * @param {LoadboardName} [loadboardName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveLbLoadboardsAuthGet: function (loadboardName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listActiveLbLoadboardsAuthGet(loadboardName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AuthenticationApiFp = AuthenticationApiFp;
/**
 * AuthenticationApi - factory interface
 * @export
 */
var AuthenticationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthenticationApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Auth
         * @param {LoadboardName} loadboardName
         * @param {CreateAuthRequest} createAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuthLoadboardsAuthLoadboardNamePost: function (loadboardName, createAuthRequest, options) {
            return localVarFp.createAuthLoadboardsAuthLoadboardNamePost(loadboardName, createAuthRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Auth
         * @param {LoadboardName} loadboardName
         * @param {boolean} [isUser]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthLoadboardsAuthLoadboardNameDelete: function (loadboardName, isUser, userId, options) {
            return localVarFp.deleteAuthLoadboardsAuthLoadboardNameDelete(loadboardName, isUser, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get External Auth Service
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet: function (loadboardName, options) {
            return localVarFp.getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet(loadboardName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Token
         * @param {LoadboardName} loadboardName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenLoadboardsAuthLoadboardNameGet: function (loadboardName, options) {
            return localVarFp.getTokenLoadboardsAuthLoadboardNameGet(loadboardName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Active Lb
         * @param {LoadboardName} [loadboardName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveLbLoadboardsAuthGet: function (loadboardName, options) {
            return localVarFp.listActiveLbLoadboardsAuthGet(loadboardName, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthenticationApiFactory = AuthenticationApiFactory;
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
var AuthenticationApi = /** @class */ (function (_super) {
    __extends(AuthenticationApi, _super);
    function AuthenticationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Auth
     * @param {LoadboardName} loadboardName
     * @param {CreateAuthRequest} createAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.createAuthLoadboardsAuthLoadboardNamePost = function (loadboardName, createAuthRequest, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).createAuthLoadboardsAuthLoadboardNamePost(loadboardName, createAuthRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Auth
     * @param {LoadboardName} loadboardName
     * @param {boolean} [isUser]
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.deleteAuthLoadboardsAuthLoadboardNameDelete = function (loadboardName, isUser, userId, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).deleteAuthLoadboardsAuthLoadboardNameDelete(loadboardName, isUser, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get External Auth Service
     * @param {LoadboardName} loadboardName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet = function (loadboardName, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).getExternalAuthServiceLoadboardsAuthLoadboardNameExternalGet(loadboardName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Token
     * @param {LoadboardName} loadboardName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.getTokenLoadboardsAuthLoadboardNameGet = function (loadboardName, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).getTokenLoadboardsAuthLoadboardNameGet(loadboardName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Active Lb
     * @param {LoadboardName} [loadboardName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.listActiveLbLoadboardsAuthGet = function (loadboardName, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).listActiveLbLoadboardsAuthGet(loadboardName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthenticationApi;
}(base_1.BaseAPI));
exports.AuthenticationApi = AuthenticationApi;
/**
 * BootItNowApi - axios parameter creator
 * @export
 */
var BootItNowApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Bin Hook Request
         * @param {LoadboardType} loadboardName
         * @param {BINRequest} bINRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBinHookRequestLoadboardsHooksLoadboardNamePost: function (loadboardName, bINRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('createBinHookRequestLoadboardsHooksLoadboardNamePost', 'loadboardName', loadboardName);
                            // verify required parameter 'bINRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createBinHookRequestLoadboardsHooksLoadboardNamePost', 'bINRequest', bINRequest);
                            localVarPath = "/loadboards/hooks/{loadboard_name}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bINRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BootItNowApiAxiosParamCreator = BootItNowApiAxiosParamCreator;
/**
 * BootItNowApi - functional programming interface
 * @export
 */
var BootItNowApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BootItNowApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Bin Hook Request
         * @param {LoadboardType} loadboardName
         * @param {BINRequest} bINRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBinHookRequestLoadboardsHooksLoadboardNamePost: function (loadboardName, bINRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBinHookRequestLoadboardsHooksLoadboardNamePost(loadboardName, bINRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BootItNowApiFp = BootItNowApiFp;
/**
 * BootItNowApi - factory interface
 * @export
 */
var BootItNowApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BootItNowApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Bin Hook Request
         * @param {LoadboardType} loadboardName
         * @param {BINRequest} bINRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBinHookRequestLoadboardsHooksLoadboardNamePost: function (loadboardName, bINRequest, options) {
            return localVarFp.createBinHookRequestLoadboardsHooksLoadboardNamePost(loadboardName, bINRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BootItNowApiFactory = BootItNowApiFactory;
/**
 * BootItNowApi - object-oriented interface
 * @export
 * @class BootItNowApi
 * @extends {BaseAPI}
 */
var BootItNowApi = /** @class */ (function (_super) {
    __extends(BootItNowApi, _super);
    function BootItNowApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Bin Hook Request
     * @param {LoadboardType} loadboardName
     * @param {BINRequest} bINRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BootItNowApi
     */
    BootItNowApi.prototype.createBinHookRequestLoadboardsHooksLoadboardNamePost = function (loadboardName, bINRequest, options) {
        var _this = this;
        return (0, exports.BootItNowApiFp)(this.configuration).createBinHookRequestLoadboardsHooksLoadboardNamePost(loadboardName, bINRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BootItNowApi;
}(base_1.BaseAPI));
exports.BootItNowApi = BootItNowApi;
/**
 * CapacitySearchApi - axios parameter creator
 * @export
 */
var CapacitySearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Capacity Search Details
         * @param {string} matchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet: function (matchId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'matchId' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet', 'matchId', matchId);
                            localVarPath = "/loadboards/capacity/search/details/{match_id}"
                                .replace("{".concat("match_id", "}"), encodeURIComponent(String(matchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search
         * @param {LoadboardType} loadboardName
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchLoadboardsLoadboardNameCapacitySearchPost: function (loadboardName, capacitySearchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchLoadboardsLoadboardNameCapacitySearchPost', 'loadboardName', loadboardName);
                            // verify required parameter 'capacitySearchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchLoadboardsLoadboardNameCapacitySearchPost', 'capacitySearchRequest', capacitySearchRequest);
                            localVarPath = "/loadboards/{loadboard_name}/capacity/search"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(capacitySearchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Multiple
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleLoadboardsCapacitySearchPost: function (capacitySearchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'capacitySearchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchMultipleLoadboardsCapacitySearchPost', 'capacitySearchRequest', capacitySearchRequest);
                            localVarPath = "/loadboards/capacity/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(capacitySearchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Multiple Retrieve
         * @param {string} internalQueryId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {boolean} [inNetwork]
         * @param {boolean} [outNetwork]
         * @param {Array<string>} [sources]
         * @param {number} [originDistance]
         * @param {number} [destinationDistance]
         * @param {Array<string>} [equipmentType]
         * @param {number} [age]
         * @param {string} [earliest]
         * @param {string} [latest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet: function (internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'internalQueryId' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet', 'internalQueryId', internalQueryId);
                            localVarPath = "/loadboards/capacity/search/{internal_query_id}"
                                .replace("{".concat("internal_query_id", "}"), encodeURIComponent(String(internalQueryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (inNetwork !== undefined) {
                                localVarQueryParameter['in_network'] = inNetwork;
                            }
                            if (outNetwork !== undefined) {
                                localVarQueryParameter['out_network'] = outNetwork;
                            }
                            if (sources) {
                                localVarQueryParameter['sources'] = sources;
                            }
                            if (originDistance !== undefined) {
                                localVarQueryParameter['origin_distance'] = originDistance;
                            }
                            if (destinationDistance !== undefined) {
                                localVarQueryParameter['destination_distance'] = destinationDistance;
                            }
                            if (equipmentType) {
                                localVarQueryParameter['equipment_type'] = equipmentType;
                            }
                            if (age !== undefined) {
                                localVarQueryParameter['age'] = age;
                            }
                            if (earliest !== undefined) {
                                localVarQueryParameter['earliest'] = (earliest instanceof Date) ?
                                    earliest.toISOString() :
                                    earliest;
                            }
                            if (latest !== undefined) {
                                localVarQueryParameter['latest'] = (latest instanceof Date) ?
                                    latest.toISOString() :
                                    latest;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Retrieve
         * @param {LoadboardType} loadboardName
         * @param {string} queryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet: function (loadboardName, queryId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet', 'loadboardName', loadboardName);
                            // verify required parameter 'queryId' is not null or undefined
                            (0, common_1.assertParamExists)('capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet', 'queryId', queryId);
                            localVarPath = "/loadboards/{loadboard_name}/capacity/search/{query_id}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)))
                                .replace("{".concat("query_id", "}"), encodeURIComponent(String(queryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Carrier Company
         * @param {Array<string>} matchIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCompanyLoadboardsCarrierGet: function (matchIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'matchIds' is not null or undefined
                            (0, common_1.assertParamExists)('getCarrierCompanyLoadboardsCarrierGet', 'matchIds', matchIds);
                            localVarPath = "/loadboards/carrier";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (matchIds) {
                                localVarQueryParameter['match_ids'] = matchIds;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CapacitySearchApiAxiosParamCreator = CapacitySearchApiAxiosParamCreator;
/**
 * CapacitySearchApi - functional programming interface
 * @export
 */
var CapacitySearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CapacitySearchApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Capacity Search Details
         * @param {string} matchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet: function (matchId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet(matchId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search
         * @param {LoadboardType} loadboardName
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchLoadboardsLoadboardNameCapacitySearchPost: function (loadboardName, capacitySearchRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.capacitySearchLoadboardsLoadboardNameCapacitySearchPost(loadboardName, capacitySearchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Multiple
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleLoadboardsCapacitySearchPost: function (capacitySearchRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.capacitySearchMultipleLoadboardsCapacitySearchPost(capacitySearchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Multiple Retrieve
         * @param {string} internalQueryId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {boolean} [inNetwork]
         * @param {boolean} [outNetwork]
         * @param {Array<string>} [sources]
         * @param {number} [originDistance]
         * @param {number} [destinationDistance]
         * @param {Array<string>} [equipmentType]
         * @param {number} [age]
         * @param {string} [earliest]
         * @param {string} [latest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet: function (internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet(internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Capacity Search Retrieve
         * @param {LoadboardType} loadboardName
         * @param {string} queryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet: function (loadboardName, queryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet(loadboardName, queryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Carrier Company
         * @param {Array<string>} matchIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCompanyLoadboardsCarrierGet: function (matchIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCarrierCompanyLoadboardsCarrierGet(matchIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CapacitySearchApiFp = CapacitySearchApiFp;
/**
 * CapacitySearchApi - factory interface
 * @export
 */
var CapacitySearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CapacitySearchApiFp)(configuration);
    return {
        /**
         *
         * @summary Capacity Search Details
         * @param {string} matchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet: function (matchId, options) {
            return localVarFp.capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet(matchId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Capacity Search
         * @param {LoadboardType} loadboardName
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchLoadboardsLoadboardNameCapacitySearchPost: function (loadboardName, capacitySearchRequest, options) {
            return localVarFp.capacitySearchLoadboardsLoadboardNameCapacitySearchPost(loadboardName, capacitySearchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Capacity Search Multiple
         * @param {CapacitySearchRequest} capacitySearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleLoadboardsCapacitySearchPost: function (capacitySearchRequest, options) {
            return localVarFp.capacitySearchMultipleLoadboardsCapacitySearchPost(capacitySearchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Capacity Search Multiple Retrieve
         * @param {string} internalQueryId
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {boolean} [inNetwork]
         * @param {boolean} [outNetwork]
         * @param {Array<string>} [sources]
         * @param {number} [originDistance]
         * @param {number} [destinationDistance]
         * @param {Array<string>} [equipmentType]
         * @param {number} [age]
         * @param {string} [earliest]
         * @param {string} [latest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet: function (internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options) {
            return localVarFp.capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet(internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Capacity Search Retrieve
         * @param {LoadboardType} loadboardName
         * @param {string} queryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet: function (loadboardName, queryId, options) {
            return localVarFp.capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet(loadboardName, queryId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Carrier Company
         * @param {Array<string>} matchIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCompanyLoadboardsCarrierGet: function (matchIds, options) {
            return localVarFp.getCarrierCompanyLoadboardsCarrierGet(matchIds, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CapacitySearchApiFactory = CapacitySearchApiFactory;
/**
 * CapacitySearchApi - object-oriented interface
 * @export
 * @class CapacitySearchApi
 * @extends {BaseAPI}
 */
var CapacitySearchApi = /** @class */ (function (_super) {
    __extends(CapacitySearchApi, _super);
    function CapacitySearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Capacity Search Details
     * @param {string} matchId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet = function (matchId, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).capacitySearchDetailsLoadboardsCapacitySearchDetailsMatchIdGet(matchId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Capacity Search
     * @param {LoadboardType} loadboardName
     * @param {CapacitySearchRequest} capacitySearchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.capacitySearchLoadboardsLoadboardNameCapacitySearchPost = function (loadboardName, capacitySearchRequest, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).capacitySearchLoadboardsLoadboardNameCapacitySearchPost(loadboardName, capacitySearchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Capacity Search Multiple
     * @param {CapacitySearchRequest} capacitySearchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.capacitySearchMultipleLoadboardsCapacitySearchPost = function (capacitySearchRequest, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).capacitySearchMultipleLoadboardsCapacitySearchPost(capacitySearchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Capacity Search Multiple Retrieve
     * @param {string} internalQueryId
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {boolean} [inNetwork]
     * @param {boolean} [outNetwork]
     * @param {Array<string>} [sources]
     * @param {number} [originDistance]
     * @param {number} [destinationDistance]
     * @param {Array<string>} [equipmentType]
     * @param {number} [age]
     * @param {string} [earliest]
     * @param {string} [latest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet = function (internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).capacitySearchMultipleRetrieveLoadboardsCapacitySearchInternalQueryIdGet(internalQueryId, page, pageSize, inNetwork, outNetwork, sources, originDistance, destinationDistance, equipmentType, age, earliest, latest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Capacity Search Retrieve
     * @param {LoadboardType} loadboardName
     * @param {string} queryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet = function (loadboardName, queryId, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).capacitySearchRetrieveLoadboardsLoadboardNameCapacitySearchQueryIdGet(loadboardName, queryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Carrier Company
     * @param {Array<string>} matchIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapacitySearchApi
     */
    CapacitySearchApi.prototype.getCarrierCompanyLoadboardsCarrierGet = function (matchIds, options) {
        var _this = this;
        return (0, exports.CapacitySearchApiFp)(this.configuration).getCarrierCompanyLoadboardsCarrierGet(matchIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CapacitySearchApi;
}(base_1.BaseAPI));
exports.CapacitySearchApi = CapacitySearchApi;
/**
 * LoadPostApi - axios parameter creator
 * @export
 */
var LoadPostApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Loadpost By Loadpost Request
         * @param {LoadboardType} loadboardName
         * @param {LoadPostRequest} loadPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost: function (loadboardName, loadPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost', 'loadboardName', loadboardName);
                            // verify required parameter 'loadPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost', 'loadPostRequest', loadPostRequest);
                            localVarPath = "/loadboards/{loadboard_name}/loadpost"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete: function (loadboardName, loadboardPostRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete', 'loadboardName', loadboardName);
                            // verify required parameter 'loadboardPostRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete', 'loadboardPostRequestId', loadboardPostRequestId);
                            localVarPath = "/loadboards/{loadboard_name}/loadpost/{loadboard_post_request_id}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)))
                                .replace("{".concat("loadboard_post_request_id", "}"), encodeURIComponent(String(loadboardPostRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet: function (loadboardName, loadboardPostRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet', 'loadboardName', loadboardName);
                            // verify required parameter 'loadboardPostRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet', 'loadboardPostRequestId', loadboardPostRequestId);
                            localVarPath = "/loadboards/{loadboard_name}/loadpost/{loadboard_post_request_id}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)))
                                .replace("{".concat("loadboard_post_request_id", "}"), encodeURIComponent(String(loadboardPostRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Loadpost Request By Shipment Id Request
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet', 'shipmentId', shipmentId);
                            localVarPath = "/loadboards/loadpost-requests/{shipment_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Loadboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadboardsLoadboardsListLoadboardsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadboards/list-loadboards";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Loadpost
         * @param {string} [shipmentId]
         * @param {boolean} [showAll]
         * @param {string} [loadReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadpostLoadboardsLoadpostGet: function (shipmentId, showAll, loadReference, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadboards/loadpost";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (showAll !== undefined) {
                                localVarQueryParameter['show_all'] = showAll;
                            }
                            if (loadReference !== undefined) {
                                localVarQueryParameter['load_reference'] = loadReference;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost: function (loadboardName, loadboardPostRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost', 'loadboardName', loadboardName);
                            // verify required parameter 'loadboardPostRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost', 'loadboardPostRequestId', loadboardPostRequestId);
                            localVarPath = "/loadboards/{loadboard_name}/loadpost/{loadboard_post_request_id}/refresh"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)))
                                .replace("{".concat("loadboard_post_request_id", "}"), encodeURIComponent(String(loadboardPostRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {LoadPostRequestUpdate} loadPostRequestUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut: function (loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadboardName' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut', 'loadboardName', loadboardName);
                            // verify required parameter 'loadboardPostRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut', 'loadboardPostRequestId', loadboardPostRequestId);
                            // verify required parameter 'loadPostRequestUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut', 'loadPostRequestUpdate', loadPostRequestUpdate);
                            localVarPath = "/loadboards/{loadboard_name}/loadpost/{loadboard_post_request_id}"
                                .replace("{".concat("loadboard_name", "}"), encodeURIComponent(String(loadboardName)))
                                .replace("{".concat("loadboard_post_request_id", "}"), encodeURIComponent(String(loadboardPostRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadPostRequestUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LoadPostApiAxiosParamCreator = LoadPostApiAxiosParamCreator;
/**
 * LoadPostApi - functional programming interface
 * @export
 */
var LoadPostApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoadPostApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Loadpost By Loadpost Request
         * @param {LoadboardType} loadboardName
         * @param {LoadPostRequest} loadPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost: function (loadboardName, loadPostRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost(loadboardName, loadPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete: function (loadboardName, loadboardPostRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete(loadboardName, loadboardPostRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet: function (loadboardName, loadboardPostRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet(loadboardName, loadboardPostRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Loadpost Request By Shipment Id Request
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Loadboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadboardsLoadboardsListLoadboardsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLoadboardsLoadboardsListLoadboardsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Loadpost
         * @param {string} [shipmentId]
         * @param {boolean} [showAll]
         * @param {string} [loadReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadpostLoadboardsLoadpostGet: function (shipmentId, showAll, loadReference, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLoadpostLoadboardsLoadpostGet(shipmentId, showAll, loadReference, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost: function (loadboardName, loadboardPostRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost(loadboardName, loadboardPostRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {LoadPostRequestUpdate} loadPostRequestUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut: function (loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut(loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LoadPostApiFp = LoadPostApiFp;
/**
 * LoadPostApi - factory interface
 * @export
 */
var LoadPostApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoadPostApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Loadpost By Loadpost Request
         * @param {LoadboardType} loadboardName
         * @param {LoadPostRequest} loadPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost: function (loadboardName, loadPostRequest, options) {
            return localVarFp.createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost(loadboardName, loadPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete: function (loadboardName, loadboardPostRequestId, options) {
            return localVarFp.deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet: function (loadboardName, loadboardPostRequestId, options) {
            return localVarFp.getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Loadpost Request By Shipment Id Request
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet: function (shipmentId, options) {
            return localVarFp.getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Loadboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadboardsLoadboardsListLoadboardsGet: function (options) {
            return localVarFp.listLoadboardsLoadboardsListLoadboardsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Loadpost
         * @param {string} [shipmentId]
         * @param {boolean} [showAll]
         * @param {string} [loadReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadpostLoadboardsLoadpostGet: function (shipmentId, showAll, loadReference, options) {
            return localVarFp.listLoadpostLoadboardsLoadpostGet(shipmentId, showAll, loadReference, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost: function (loadboardName, loadboardPostRequestId, options) {
            return localVarFp.refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Loadpost
         * @param {LoadboardType} loadboardName
         * @param {string} loadboardPostRequestId
         * @param {LoadPostRequestUpdate} loadPostRequestUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut: function (loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options) {
            return localVarFp.updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut(loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoadPostApiFactory = LoadPostApiFactory;
/**
 * LoadPostApi - object-oriented interface
 * @export
 * @class LoadPostApi
 * @extends {BaseAPI}
 */
var LoadPostApi = /** @class */ (function (_super) {
    __extends(LoadPostApi, _super);
    function LoadPostApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Loadpost By Loadpost Request
     * @param {LoadboardType} loadboardName
     * @param {LoadPostRequest} loadPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost = function (loadboardName, loadPostRequest, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).createLoadpostByLoadpostRequestLoadboardsLoadboardNameLoadpostPost(loadboardName, loadPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Loadpost
     * @param {LoadboardType} loadboardName
     * @param {string} loadboardPostRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete = function (loadboardName, loadboardPostRequestId, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).deleteLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdDelete(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Loadpost
     * @param {LoadboardType} loadboardName
     * @param {string} loadboardPostRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet = function (loadboardName, loadboardPostRequestId, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).getLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdGet(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Loadpost Request By Shipment Id Request
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).getLoadpostRequestByShipmentIdRequestLoadboardsLoadpostRequestsShipmentIdGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Loadboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.listLoadboardsLoadboardsListLoadboardsGet = function (options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).listLoadboardsLoadboardsListLoadboardsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Loadpost
     * @param {string} [shipmentId]
     * @param {boolean} [showAll]
     * @param {string} [loadReference]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.listLoadpostLoadboardsLoadpostGet = function (shipmentId, showAll, loadReference, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).listLoadpostLoadboardsLoadpostGet(shipmentId, showAll, loadReference, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Refresh Loadpost
     * @param {LoadboardType} loadboardName
     * @param {string} loadboardPostRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost = function (loadboardName, loadboardPostRequestId, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).refreshLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdRefreshPost(loadboardName, loadboardPostRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Loadpost
     * @param {LoadboardType} loadboardName
     * @param {string} loadboardPostRequestId
     * @param {LoadPostRequestUpdate} loadPostRequestUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadPostApi
     */
    LoadPostApi.prototype.updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut = function (loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options) {
        var _this = this;
        return (0, exports.LoadPostApiFp)(this.configuration).updateLoadpostLoadboardsLoadboardNameLoadpostLoadboardPostRequestIdPut(loadboardName, loadboardPostRequestId, loadPostRequestUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoadPostApi;
}(base_1.BaseAPI));
exports.LoadPostApi = LoadPostApi;
/**
 * SettingsApi - axios parameter creator
 * @export
 */
var SettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Global Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettingsLoadboardsSettingsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadboards/settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Global Settings
         * @param {GlobalSettingsRequest} globalSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalSettingsLoadboardsSettingsPut: function (globalSettingsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'globalSettingsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateGlobalSettingsLoadboardsSettingsPut', 'globalSettingsRequest', globalSettingsRequest);
                            localVarPath = "/loadboards/settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(globalSettingsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SettingsApiAxiosParamCreator = SettingsApiAxiosParamCreator;
/**
 * SettingsApi - functional programming interface
 * @export
 */
var SettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Global Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettingsLoadboardsSettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGlobalSettingsLoadboardsSettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Global Settings
         * @param {GlobalSettingsRequest} globalSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalSettingsLoadboardsSettingsPut: function (globalSettingsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateGlobalSettingsLoadboardsSettingsPut(globalSettingsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SettingsApiFp = SettingsApiFp;
/**
 * SettingsApi - factory interface
 * @export
 */
var SettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SettingsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Global Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettingsLoadboardsSettingsGet: function (options) {
            return localVarFp.getGlobalSettingsLoadboardsSettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Global Settings
         * @param {GlobalSettingsRequest} globalSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalSettingsLoadboardsSettingsPut: function (globalSettingsRequest, options) {
            return localVarFp.updateGlobalSettingsLoadboardsSettingsPut(globalSettingsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SettingsApiFactory = SettingsApiFactory;
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
var SettingsApi = /** @class */ (function (_super) {
    __extends(SettingsApi, _super);
    function SettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Global Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getGlobalSettingsLoadboardsSettingsGet = function (options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getGlobalSettingsLoadboardsSettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Global Settings
     * @param {GlobalSettingsRequest} globalSettingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateGlobalSettingsLoadboardsSettingsPut = function (globalSettingsRequest, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateGlobalSettingsLoadboardsSettingsPut(globalSettingsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SettingsApi;
}(base_1.BaseAPI));
exports.SettingsApi = SettingsApi;
